// extracted by mini-css-extract-plugin
module.exports = {"List":"WorldBoard_List__1-ORZ"};